// Russian
export const ru = {
    weeklyRewards: 'Еженедельные награды через',
    days: 'дн.',
    hours: 'ч.',
    minutes: 'мин.',
    seconds: 'сек.',
    authenticating: 'Аутентификация',
    verifyWallet: 'Пожалуйста, подождите, пока мы проверяем ваш кошелек',
    authRequired: 'Требуется аутентификация',
    authFailed: 'Ошибка аутентификации. Пожалуйста, попробуйте снова.',
    points: 'Очки',
    rank: 'Ранг',
    of: 'из',
    players: 'игроков',
    weeklyTopPlayers: 'Лучшие игроки недели',
    thisWeekLeaderboard: 'Рейтинг этой недели',
    rankingsReset: 'Рейтинг сбрасывается каждое воскресенье в полночь UTC',
    yourPoints: 'Ваши очки',
    dailyRewardAvailable: 'Доступна ежедневная награда!',
    nextClaimAvailable: 'Следующее получение доступно через:',
    claimDailyReward: 'Получить ежедневную награду',
    claiming: 'Получение...',
    multiplier: 'Множитель',
    bonusPointsMultiplier: 'Множитель бонусных очков',
    outOf: 'из',
    loading: 'Загрузка...',
    errorLoading: 'Ошибка загрузки',
    noEntries: 'Нет записей',
    leaderboard: 'Рейтинг',
    tasks: 'Задания',
    rules: 'Правила',
    profile: 'Профиль',
    comingSoon: 'Скоро...',
    completedTasks: 'Выполненные задания',
    dailyRewardsClaimed: 'Полученные ежедневные награды',
    times: 'раз',
    recentActivity: 'Недавняя активность',
    noRewardsClaimed: 'Награды еще не получены',
    dailyReward: 'Ежедневная награда',
    howItWorks: 'Как это работает',
    welcomeMessage:
        'Добро пожаловать в Coinomi Rewards! Зарабатывайте очки, выполняя различные задания, и поднимайтесь в рейтинге.',
    dailyRewardsTitle: 'Ежедневные награды',
    dailyRewardsRules: [
        'Получайте ежедневную награду каждые 24 часа',
        'Каждое получение даёт 100 очков',
        'Очки умножаются на ваш множитель',
    ],
    multiplierBonusesTitle: 'Бонусы множителя',
    multiplierBonusesRules: [
        'Начните с множителя 1x',
        'Подключите Telegram для бонуса +10%',
        'Подтвердите email для бонуса +10%',
        'Бонусы суммируются для максимальных наград',
    ],
    leaderboardTitle: 'Рейтинг',
    leaderboardRules: [
        'Соревнуйтесь с другими игроками',
        'Рейтинг обновляется в реальном времени',
        'Лучшие игроки получают особые награды',
    ],
    boostEarningsTitle: 'Увеличьте заработок',
    boostEarningsRules: [
        'Выполняйте испытания для бонусов',
        'Присоединитесь к нашему сообществу в Telegram',
        'Оставайтесь активными для максимальных наград',
    ],
    challenges: 'Испытания',
    telegramChallenge: 'Испытание Telegram',
    emailChallenge: 'Испытание Email',
    connectTelegram: 'Подключить Telegram',
    shareEmail: 'Поделиться email',
    telegramSuccess: '🎉 Поздравляем! Теперь вы получаете постоянный бонус 10% ко всем наградам!',
    telegramPrompt:
        'Подключите свой аккаунт Telegram, чтобы получить постоянный бонус 10% ко всем наградам!',
    emailSuccess: '🎉 Поздравляем! Теперь вы получаете постоянный бонус 10% ко всем наградам!',
    emailPrompt: 'Поделитесь своим email, чтобы получить постоянный бонус 10% ко всем наградам!',
    connectEmail: 'Подключить email',
    cancel: 'Отмена',
    emailPrivacy: 'Мы используем ваш email только для важных обновлений и уведомлений о наградах.',
    connectYourEmail: 'Подключите свой email',
    emailBonus: '🎉 Получите постоянный бонус 10% ко всем наградам, подключив свой email!',
    enterValidEmail: 'Пожалуйста, введите действительный email адрес',
    emailAddress: 'Email адрес',
    errorSavingEmail: 'Ошибка при сохранении email. Пожалуйста, попробуйте снова.',
    claimButton: 'Получить',
    earnedReward: 'Заработанная награда',
    rewardValue: '{{amount}} Очков',
    claimingReward: 'Получение...',
    claimSuccess: 'Успешно получено {{amount}} очков!',
    claimError: 'Ошибка получения. Пожалуйста, попробуйте снова.',
    privacyDisclaimer:
        'Coinomi не собирает личные данные; сторонняя система безопасно управляет очками и социальными связями.',
    streakBonus: 'Бонус за серию',
    streakDays: '{{days}}/5 Дней',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Дополнительно',
    streakDescription: 'Получайте награды 5 дней подряд для максимального бонуса',
    streakToday: 'Сегодня',
    streakMissed: 'Пропущено',
    streakComplete: 'Завершено',
    streakActive: 'Активная серия',
    streakLost: 'Серия потеряна',
    streakNext: 'Следующий',
    home: 'Главная',
    currentStreak: 'Текущая серия',
    totalClaims: 'Всего получено',
    userStats: 'Ваша статистика',
    referrals: 'Рефералы',
    referralProgram: 'Реферальная программа',
    howReferralWorks: 'Как работают рефералы:',
    referralSteps: [
        'Поделитесь своей реферальной ссылкой с друзьями',
        'Когда они присоединяются по вашей ссылке, они становятся вашими рефералами',
        'Получайте бонусные очки за каждого активного реферала',
        'Отслеживайте своих рефералов и заработок здесь',
    ],
    referralRewards: 'Начисляемые реферальные очки:',
    referralBonuses: ['100 очков за реферала', '10% от всех очков, заработанных вашими рефералами'],
    yourReferralLink: 'Ваша реферальная ссылка',
    copyToClipboard: 'Копировать в буфер обмена',
    linkCopied: 'Ссылка скопирована в буфер обмена!',
    totalReferrals: 'Всего рефералов',
    yourReferralCode: 'Ваш реферальный код',
    referralCodeCopied: 'Реферальный код скопирован!',
    editReferralCode: 'Изменить реферальный код',
    editReferralCodeInstructions:
        'Выберите новый реферальный код. Должен содержать минимум 5 символов и может включать буквы и цифры.',
    newReferralCode: 'Новый реферальный код',
    referralCodeRequirements: 'Минимум 5 символов, только буквы и цифры',
    updating: 'Обновление...',
    update: 'Обновить',
    referralCodeTaken: 'Этот реферальный код уже используется',
    haveReferralCode: 'У вас есть реферальный код?',
    enterReferralCodePrompt:
        'Если вас кто-то пригласил, введите их код здесь, чтобы связать аккаунты.',
    enterReferralCode: 'Введите реферальный код',
    enterReferralCodeInstructions: 'Введите реферальный код, которым с вами поделились.',
    referralCode: 'Реферальный код',
    referralCodeFormat: 'Только буквы и цифры',
    submitting: 'Отправка...',
    submit: 'Отправить',
    enterCode: 'Введите код',
    pleaseAddtoken: 'Пожалуйста, добавьте параметр token в URL',
    authenticationError: 'Произошла ошибка при аутентификации',
    noUserFound: 'Пользователь не найден',
    userNotFoundMessage: 'Не удалось найти данные пользователя',
    backToHome: 'Вернуться на главную',
    retry: 'Повторить',
    baseMultiplier: 'Базовый множитель',
    telegramBonus: 'Бонус Telegram',
    referralChallenge: 'Реферальное испытание',
    referralChallengePrompt:
        'Пригласите друзей и получите бонусные очки! Получайте 100 очков за каждого реферала плюс 10% от их заработка.',
    startReferring: 'Начать приглашать',
    referralSuccess:
        '🎉 Поздравляем! Вы успешно пригласили пользователей и зарабатываете бонусные очки!',
    unranked: 'Без ранга',
    noPlayersYet: 'Станьте первым участником!',
    shareVia: 'Поделиться через',
    shareOn: 'Поделиться в {{network}}',
    shareInviteText:
        '🚀 Я зарабатываю бесплатную криптовалюту с @CoinomiWallet!\n\nСкачайте Coinomi на coinomi.com/downloads и введите мой реферальный код {{referralCode}}, чтобы получить бонус при присоединении к #Coinomi Rewards в приложении.',
    player: 'Игрок',
    score: 'Очки',
    youHaveReferred_zero: 'Вы еще не пригласили друзей',
    youHaveReferred_one: 'Вы пригласили {{count}} друга',
    youHaveReferred_few: 'Вы пригласили {{count}} друзей',
    youHaveReferred_many: 'Вы пригласили {{count}} друзей',
    youHaveReferred_other: 'Вы пригласили {{count}} друзей',
    referYourFriends: 'Пригласите друзей',
    dailyRewardTooltip: 'Возвращайтесь каждый день, чтобы получить очки и награды',
    weeklyRewardTooltip: 'Награды распределяются еженедельно',
    copy: 'Копировать',
    // Twitter Challenge
    twitterChallenge: 'Твиттер Челлендж',
    connectTwitter: 'Подключить Twitter',
    twitterSuccess: '🎉 Поздравляем! Теперь вы получаете постоянный 10% бонус на все награды!',
    twitterPrompt:
        'Привяжите свой аккаунт Twitter, чтобы получить постоянный 10% бонус на все награды!',
    pleaseAddUserId: 'Пожалуйста, добавьте параметр userId в URL',
    emailChallengePrompt:
        'Поделитесь своим email, чтобы получить постоянный бонус 10% ко всем наградам!',
    emailChallengeSuccess:
        '🎉 Подключено! Теперь вы получаете постоянный бонус 10% ко всем наградам!',
    followKoalaWalletChallenge: 'Подпишитесь на @coinomiWallet в Twitter, чтобы поддержать нас!',
    twitterAuthSuccessTitle: 'Twitter успешно подключён!',
    twitterAuthSuccessMessage:
        'Аккаунт Twitter успешно подключён. Теперь вы можете продолжить использовать приложение.',
    continueToApp: 'Продолжить в приложение',
    twitter_like: 'Лайкнул твит',
    twitter_retweet: 'Ретвитнул твит',
    disconnect: 'Отключить',
    followCoinomiWallet: 'Подпишитесь на @coinomiWallet в Twitter, чтобы поддержать нас!',
    connectedBonus: '🎉 Подключено! Теперь вы получаете постоянный бонус 10% на все награды!',
};
